import { DropdownFilterOption, FilterItems } from '@odin-labs/components';
import { GetJobsiteWorkersOrderByField } from 'apollo/generated/client-operations';
import {
  PageSearchParams,
  ensureDistinctItems,
  ensureNonEmptyItems,
} from 'utils';
import { getSelectOptions } from 'components/utils';

export type WorkersFilters = Pick<
  PageSearchParams,
  'currentlyOnsite' | 'trades' | 'jobTitles' | 'search'
>;

export type WorkerFiltersOptions = {
  trades: DropdownFilterOption[];
  jobTitles: DropdownFilterOption[];
};

export const getFiltersOptions = (values: string[]): DropdownFilterOption[] =>
  getSelectOptions({
    values: ensureDistinctItems(ensureNonEmptyItems(values ?? [])),
  });

export const getFilterItems = ({
  filtersOptions,
  currentlyOnsite,
  trades,
  jobTitles,
  search,
}: {
  filtersOptions: WorkerFiltersOptions;
  currentlyOnsite: string;
  trades: string[];
  jobTitles: string[];
  search: string;
}): FilterItems<WorkersFilters> => ({
  currentlyOnsite: {
    header: 'On site',
    type: 'checkbox',
    defaultValue: currentlyOnsite,
  },
  trades: {
    header: 'Trade',
    type: 'dropdown',
    defaultValue: trades,
    componentProps: { options: filtersOptions.trades },
  },
  jobTitles: {
    header: 'Title',
    type: 'dropdown',
    defaultValue: jobTitles,
    componentProps: { options: filtersOptions.jobTitles },
  },
  search: {
    header: '',
    type: 'searchInput',
    defaultValue: search,
    isVisibleOutsideFilterOnMobile: true,
  },
});

export const orderByFields: Record<string, GetJobsiteWorkersOrderByField> = {
  name: GetJobsiteWorkersOrderByField.Name,
  jobsiteName: GetJobsiteWorkersOrderByField.JobsiteName,
  birthDate: GetJobsiteWorkersOrderByField.BirthDate,
  trade: GetJobsiteWorkersOrderByField.Trade,
  contractor: GetJobsiteWorkersOrderByField.Contractor,
  orientationDate: GetJobsiteWorkersOrderByField.OrientationDate,
  orientationStatus: GetJobsiteWorkersOrderByField.OrientationStatus,
  siteSpecificStatus: GetJobsiteWorkersOrderByField.SiteSpecificStatus,
};
